import { useContext } from "react";
import { ResourceFormApiContext } from "src/components/Form/ResourceFormApiContext.tsx";

export const useResourceFormApi = () => {
  const context = useContext(ResourceFormApiContext);
  if (!context) {
    throw new Error("useFormApi must be used withing FormApiContext.Provider");
  }
  return context;
};
